import { render, staticRenderFns } from "./StoreGoodsInfo.vue?vue&type=template&id=37a2d48d&scoped=true&"
import script from "./StoreGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./StoreGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./StoreGoodsInfo.vue?vue&type=style&index=0&id=37a2d48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2d48d",
  null
  
)

export default component.exports